import SpitialLogin from "../../components/login/wrapper";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import RootLayout from "../layout";
import { hasAuthenticatedSession } from "../../services/authStorage";

const checkAuth = () => hasAuthenticatedSession();

const LoginPage = () => {
  const auth = checkAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth) {
      navigate("/profile", { replace: true });
    }
  }, [auth, navigate]);

  if (auth) return null;

  return (
    <RootLayout>
      <SpitialLogin />
    </RootLayout>
  );
};

export default LoginPage;
